import {
  URL_CHANGE,
  type UrlChangeAction,
} from '@/domains/core/routing/broadcaster/RoutingBroadcast.actions';
import {
  initialState,
  type TrackingState,
} from '@/domains/productDiscovery/ProductPage/interfaces/TrackingState.model';

export default function reducer(
  state: TrackingState = initialState,
  action: UrlChangeAction,
): TrackingState {
  switch (action.type) {
    case URL_CHANGE:
      return {
        isLanding: false,
      };

    default:
      return state;
  }
}
